(() => {
  // Handles clicking on product__plan (no longer label).
  // Sets the new active radio (selling plan).
  document.querySelectorAll("[js-bundle-label]").forEach((element) => {
    element.addEventListener("click", () => {
      const radio = element
        .closest("[js-bundle-radio]")
        ?.querySelector('[type="radio"]');
      if (!radio || radio.checked) return;

      radio.click();
    });
  });
})();

(() => {
  const selects = document.querySelectorAll("[js-frequency-plans]");

  function updateActive(newRadio) {
    if (!newRadio) return;
    const planGroup = newRadio.closest("[data-selling-plan-group]");
    const activePlanGroup = document.querySelector(
      "[data-selling-plan-group].is-active"
    );

    activePlanGroup.classList.remove("is-active");
    planGroup.classList.add("is-active");
  }

  selects.forEach((element) => {
    element.addEventListener("change", (event) => {
      event.stopPropagation();

      selects.forEach((select) => {
        if (select == element) return;

        select.value = element.value;
      });

      const newRadio = document.querySelector(
        `[js-bundle-radio] input[value="${element.value}"]`
      );
      const radioCustomLabel = newRadio.parentElement.querySelector("[js-bundle-label]");

      radioCustomLabel.click();
      updateActive(newRadio);
      
      requestAnimationFrame(() => {
        radioCustomLabel.click();
      })
    });
  });

  // Fix cache issue from going back to the page using the browser "back" button
  setTimeout(() => {
    updateActive(
      document.querySelector('[js-bundle-radio] [type="radio"]:checked')
    );
  }, 300);
})();
